import { Component, OnInit } from '@angular/core';
import { EditNotificationModel } from '../../../models/inModels/MessageModel';
import { Message } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../services/notifications/NotificationService';

@Component({
	selector: 'app-notification-edit',
	templateUrl: './notification-edit.component.html',
	styleUrls: ['./notification-edit.component.css']
})
export class NotificationEditComponent implements OnInit {
	id;
	model: EditNotificationModel;
	loading = false;
	error: Message[];
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private notificationService: NotificationService
	) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit(): void {
		this.getNotification();
	}
	getNotification() {
		this.loading = true;
		this.notificationService.get(this.id).then(
			result => {
				this.model = new EditNotificationModel(result);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		)
	}

	goBack() {
		this.router.navigate(['/notification']);
	}

	save() {
		this.loading = true;
		this.notificationService.update(this.model).then(
			result => {

				this.model = new EditNotificationModel(result);
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/notification/notification-edit/notification-edit.component.ts